// Importar configuração de API
import { API_BASE_URL } from './config/api';

// Usar URL baseada no ambiente (localhost em dev, domínio atual em produção)
const API_URL = API_BASE_URL;

// Orçamentos para Admin
export const getQuotesForAdmin = async (token) => {
  try {
    const response = await fetch(`${API_URL}/api/admin/quotes`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Erro ${response.status}: ${errorText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Erro ao buscar orçamentos:', error);
    throw error;
  }
};

export const updateQuoteStatus = async (token, quoteId, status) => {
  try {
    const response = await fetch(`${API_URL}/api/admin/quotes/${quoteId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ status })
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Erro ${response.status}: ${errorText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Erro ao atualizar status do orçamento:', error);
    throw error;
  }
};